export default __webpack_public_path__ + "static/adventofcode-3ac3a5f42c3be8573dead43fc6e0da57.png";